module.exports = __webpack_public_path__ + "static/media/LemonCards.a93482f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/IoT/LemonCards.png
// module id = 470
// module chunks = 0